module.exports = __webpack_public_path__ + "img/logo.10cb7e38.png";